import { render } from "./ShimmerLoginCarousel.vue?vue&type=template&id=283fff90"
import script from "./ShimmerLoginCarousel.vue?vue&type=script&lang=js"
export * from "./ShimmerLoginCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__